import { Pipe, PipeTransform } from '@angular/core';
import { FileTypeCode } from '../security-deposit/applications/models/applications.model';

@Pipe({
  standalone: false, name: 'fileType' })
export class FileTypePipe implements PipeTransform {
  private types: { [key: string]: string } = {};

  constructor() {
    this.types[FileTypeCode.identityDocument] = 'Identification';
    this.types[FileTypeCode.employmentVerificationLetter] = 'Employment';
    this.types[FileTypeCode.studentEligibilityCertificate] = 'Employment';
    this.types[FileTypeCode.proofOfIncome] = 'Employment';
    this.types[FileTypeCode.bankStatement] = 'Bank Statement';
    this.types[FileTypeCode.paymentStub] = 'Bank Statement';
    this.types[FileTypeCode.w9w8Form] = 'Tax Form';
    this.types[FileTypeCode.contract] = 'Contract';
    this.types[FileTypeCode.smartScreening] = 'S.M.A.R.T. Screening';
    this.types[FileTypeCode.other] = 'Other';
  }

  transform(value: FileTypeCode): string {
    return this.types[value] ?? 'Unknown';
  }
}
